import _classCallCheck from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/gonzalo/wfdev/webfarming-app-client/node_modules/@babel/runtime/helpers/esm/createClass";
import Location from '../../geom/Location';
import Polygon from '../../geom/Polygon';
import PointLocation from '../PointLocation';
import PointOnGeometryLocator from './PointOnGeometryLocator';
import GeometryCollectionIterator from '../../geom/GeometryCollectionIterator';
import GeometryCollection from '../../geom/GeometryCollection';
var SimplePointInAreaLocator = /*#__PURE__*/function () {
  function SimplePointInAreaLocator() {
    _classCallCheck(this, SimplePointInAreaLocator);
    SimplePointInAreaLocator.constructor_.apply(this, arguments);
  }
  _createClass(SimplePointInAreaLocator, [{
    key: "locate",
    value: function locate(p) {
      return SimplePointInAreaLocator.locate(p, this._geom);
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [PointOnGeometryLocator];
    }
  }], [{
    key: "constructor_",
    value: function constructor_() {
      this._geom = null;
      var geom = arguments[0];
      this._geom = geom;
    }
  }, {
    key: "locatePointInPolygon",
    value: function locatePointInPolygon(p, poly) {
      if (poly.isEmpty()) return Location.EXTERIOR;
      var shell = poly.getExteriorRing();
      var shellLoc = SimplePointInAreaLocator.locatePointInRing(p, shell);
      if (shellLoc !== Location.INTERIOR) return shellLoc;
      for (var i = 0; i < poly.getNumInteriorRing(); i++) {
        var hole = poly.getInteriorRingN(i);
        var holeLoc = SimplePointInAreaLocator.locatePointInRing(p, hole);
        if (holeLoc === Location.BOUNDARY) return Location.BOUNDARY;
        if (holeLoc === Location.INTERIOR) return Location.EXTERIOR;
      }
      return Location.INTERIOR;
    }
  }, {
    key: "locatePointInRing",
    value: function locatePointInRing(p, ring) {
      if (!ring.getEnvelopeInternal().intersects(p)) return Location.EXTERIOR;
      return PointLocation.locateInRing(p, ring.getCoordinates());
    }
  }, {
    key: "containsPointInPolygon",
    value: function containsPointInPolygon(p, poly) {
      return Location.EXTERIOR !== SimplePointInAreaLocator.locatePointInPolygon(p, poly);
    }
  }, {
    key: "locateInGeometry",
    value: function locateInGeometry(p, geom) {
      if (geom instanceof Polygon) return SimplePointInAreaLocator.locatePointInPolygon(p, geom);
      if (geom instanceof GeometryCollection) {
        var geomi = new GeometryCollectionIterator(geom);
        while (geomi.hasNext()) {
          var g2 = geomi.next();
          if (g2 !== geom) {
            var loc = SimplePointInAreaLocator.locateInGeometry(p, g2);
            if (loc !== Location.EXTERIOR) return loc;
          }
        }
      }
      return Location.EXTERIOR;
    }
  }, {
    key: "isContained",
    value: function isContained(p, geom) {
      return Location.EXTERIOR !== SimplePointInAreaLocator.locate(p, geom);
    }
  }, {
    key: "locate",
    value: function locate(p, geom) {
      if (geom.isEmpty()) return Location.EXTERIOR;
      if (!geom.getEnvelopeInternal().intersects(p)) return Location.EXTERIOR;
      return SimplePointInAreaLocator.locateInGeometry(p, geom);
    }
  }]);
  return SimplePointInAreaLocator;
}();
export { SimplePointInAreaLocator as default };